export default {
    maxBSYear: 2100,
    minBSYear: 1970,

    outputSeparator: "-",
}
